<template>
  <div class="content">
    <DataReportSelect selectTabsType="orderBasicData" @event-filter="fetchData">
      <span slot="orderBasicData">
        <div class="charts-warp">
          <div class="charts-container">
            <div style="display:flex">
              <div style="width:256px;margin-right:16px">
                <ContentBox style="height: 400px">
                  <div class="chart-title" slot="title">
                    <div class="title">曝光数据概览</div>
                  </div>
                  <!-- <div class="exposure-amount" v-if="exposureAmount !== 0">{{exposureAmount}}</div> -->
                  <VePie :settings="exposurePie.settings" :data="exposurePie.data" :loading="loading" :extend="exposurePie.extend">
                    <ChartDataEmpty class="no-message" v-if="!loading && exposurePie.data.rows.length === 0" />
                  </VePie>
                </ContentBox>
              </div>
              <div style="width:calc(100% - 272px)">
                <ContentBox style="height: 400px">
                  <div class="chart-title" slot="title">
                    <div class="title">曲线图</div>
                  </div>
                  <ChartDataEmpty class="chart-data-empty" v-show="!loading && lineOption.data.length === 0" />
                  <LineChart id="line" v-show="lineOption.data.length > 0" :option="lineOption" height="300px"></LineChart>
                </ContentBox>
              </div>
            </div>
            <div>
              <div>
                <ContentBox>
                  <div class="download" slot="title">
                    <p class="title">详细数据</p>
                    <p class="title-right">
                      <el-button size="mini" style="display: flex; justify-items: center; align-items: center" :loading="loadingExport" @click="fetchData('export')">
                        <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                      </el-button>
                    </p>
                  </div>
                  <Table :props="table.props" :header="header" :data="table.data" />
                  <pagination
                    v-bind:currentpage="currentPage"
                    v-bind:pagesize="pageSize"
                    v-bind:totalcount="totalCount"
                    @handle-size-change="handleSizeChange"
                    @handle-current-change="handleCurrentChange"
                  ></pagination>
                </ContentBox>
              </div>
            </div>
          </div>
        </div>
      </span>
    </DataReportSelect>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import DataReportSelect from '@/components/DataReportSelect'
import ChartDataEmpty from '@/components/ChartDataEmpty'
import LineChart from '@/components/charts/LineChart'
import VePie from 'v-charts/lib/pie.common'
import 'v-charts/lib/style.css'
import downLoad from '@/utils/downLoad';

export default {
  inject: ['searchData'],
  components: {
    Table,
    DataReportSelect,
    LineChart,
    VePie,
    ChartDataEmpty
  },
  props: ['order'],
  data() {
    return {
      // 筛选条件
      // searchFilter: this.genDefaultFilter(),
      // 曝光曲线图
      lineOption: {
        config: {
          legendData: ['曝光', '点击'],
          xData: ['2020/01/02', '2020/01/03', '2020/01/04', '2020/01/05'],
          theme: ['#f59a23', '#1890ff']
        },
        data: [
          { data: [], name: '曝光' },
          { data: [], name: '点击' }
        ]
      },
      isShowSelect: true,
      isShowTimePicker: true,
      // 分页
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      // 曝光量饼图
      exposurePie: {
        total: 0,
        data: {
          columns: ['xData', 'yData'],
          rows: []
        },
        settings: {
          offsetY: 90,
          label: {
            show: false,
            normal: {
              show: true,
              position: 'center',
              formatter: (event) => {
                let that = this
                let total = 1
                if (that.exposurePie.total !== 0) {
                  total = that.exposurePie.total
                }
                let percent =
                  Math.round((that.exposurePie.data.rows[0].yData / total) * 10000) /
                  100.0
                return percent + '%'
              },
              textStyle: {
                fontSize: 24,
                color: 'rgba(0, 0, 0, 0.85)'
              }
            }
          }
        },
        extend: {
          tooltip: {
            confine: true
          },
          series: {
            radius: ['50%', '65%']
          },
          legend: {
            bottom: 140,
            itemGap: 20,
            orient: 'vertical',
            left: 10,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
              color: '#77899c',
              rich: {
                uname: {
                  width: 100
                },
                unum: {
                  // color: '#4ed139',
                  width: 40,
                  align: 'right'
                }
              }
            },
            formatter: (name) => {
              let that = this
              // let legendName = ''
              let num = 0
              if (name.indexOf('曝光量') > -1) {
                num = that.exposurePie.data.rows[0].yData
                return `{uname|曝光量}{unum|${num}}`
              } else {
                num = that.exposurePie.data.rows[1].yData
                return `{uname|待投放量}{unum|${num}}`
              }
            }
          },
          color: [
            '#FF8B00',
            '#F0F2F5',
            '#B1FC03',
            '#35FC03',
            '#FC0335',
            '#FD783F',
            '#FEA37C',
            '#03FC4E',
            '#FC03B1',
            '#7CD7FE',
            '#3FC4FD',
            '#03FCCA',
            '#CA03FC',
            '#4E03FC',
            '#0335FC',
            '#03B1FC'
          ]
        }
      },
      exposureAmount: 0,
      loading: false,
      loadingExport: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '日期',
            align: 'left',
            prop: 'statData',
            'show-overflow-tooltip': true
          },
          {
            label: '时间',
            align: 'left',
            prop: 'hour',
            'show-overflow-tooltip': true,
            formatter: (row) => {
              if (row.hour) {
                const hour = row.hour || ''
                let basic = hour.length === 1 ? '0' + hour : hour
                if (basic === '24') {
                  basic = '00'
                }
                return basic + ':00 - ' + basic + ':59'
              }
            }
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'show-overflow-tooltip': true
          },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'pv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv || 0).toLocaleString()
            }
          },
          {
            label: '点击量(CV)',
            align: 'right',
            prop: 'clickPv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.cv || 0).toLocaleString()
            }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    header() {
      let header = this.table.header
      if (this.searchData.model.showType === 0) {
        header = this.table.header.filter((item) => item.prop !== 'hour')
      } else {
        header = this.table.header
      }
      return header
    }
  },
  methods: {
    handleExport() {
      this.loading = false
      this.loadingExport = true
      let form = JSON.parse(JSON.stringify(this.searchData.model))
      form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
      form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
      form.pageSize = 20000
      form.pageNo = 1
      const options = {
        url: 'api/dsp/report/exportBaseExcel',
        data: form
      }
      downLoad(options)
        .then(res => {
          this.loadingExport = false
        })
        .catch(() => {
          this.loadingExport = false
        })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    // 点击筛选，输出图表数据
    fetchData(type) {
      if (this.searchData.model.orderId) {
        this.loading = true
        let form = JSON.parse(JSON.stringify(this.searchData.model))
        form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
        form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
        if (type === 'export') {
          this.handleExport()
          return
        }
        this.$service.getOrderBaseReport(form).then((data) => {
          // this.loading = false
          this.lineOption.config.xData = data.lineList.map((item) => item.xData)
          this.lineOption.data[0].data = data.lineList.map((item) => item.yData)
          this.lineOption.data[1].data = data.clickLineList.map((item) => item.yData)
          this.exposureAmount = data.totalPv || 0
          let remain = data.totalContract - data.totalPv
          remain = remain > 0 ? remain : 0
          this.exposurePie.data.rows = [
            { xData: '曝光量', yData: data.totalPv || 0 },
            { xData: '待投放量', yData: remain }
          ]
          this.exposurePie.total = this.exposurePie.data.rows.reduce(
            (a, b) => a.yData + b.yData
          )
        })
        this.pageSize = 10
        this.currentPage = 1
        this.getTableData()
        setTimeout(() => {
          this.loading = false
        }, 300)
      }
    },
    getTableData() {
      let form = JSON.parse(JSON.stringify(this.searchData.model))
      form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
      form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
      form.pageSize = this.pageSize
      form.pageNo = this.currentPage
      this.$service.getBasePageList(form).then((data) => {
        this.table.data = data.rows || []
        const totalCount = Number(data.total)
        this.totalCount = isNaN(totalCount) ? 0 : totalCount
      })
    }
  },
  created() {
    if (this.$route.params.order) {
      const order = this.$route.params.order
      this.searchData.model.orderId = order.orderId
      this.searchData.isFilter = true
    }
    if (this.searchData.isFilter) {
      this.fetchData()
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  // overflow: auto;
  // height: calc(100vh - 60px);
  position relative
.header-serach
  position relative
.charts-warp
  // height: calc(100vh - 202px);
  display flex
  flex 1
  // padding: 0px 16px;
  // overflow: auto;
  // box-sizing: border-box;
.charts-container
  width 100%
  height 100%
  margin 0 16px
.card
  padding 20px
  font-size 14px
  color #fff
  background #fff
  margin-bottom 0
  box-shadow 0 0 20px 0 rgba(0, 0, 0, 0.12)
.card.pv
  background #409EFF
.card.yuan
  background #15ca20
.card.cpm
  background #fc4c00
p
  margin 0px
.card p:last-child
  font-size 35px
  padding 10px 0 0 0
.chart-title, .download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.title
  font-size 16px
  font-weight 500
.exposure-data.content-list
  margin-top 0
.select-data
  font-size 16px
  line-height 34px
.title-right
  text-indent 0
.right-date
  display flex
  justify-content flex-end
.exposure-amount
  font-size 26px
  font-weight 500
  text-align center
  margin 20px
.no-message.chart-data-empty
  height 300px
.chart-data-empty
  height 300px
</style>
